export const translations = {
  en: {
    nav: {
      links: [
        { href: "#features", label: "Features" },
        { href: "#how-it-works", label: "How it Works" },
        { href: "#showcase", label: "Showcase" },
        { href: "#testimonials", label: "Voices" },
        { href: "#contact", label: "Contact" },
      ],
      cta: "Get the Demo App",
    },
    hero: {
      badge: "Flutter-powered · Immersive · Native",
      sub: "Paigez.ai transforms static PDF magazines into fully immersive, interactive experiences — a native super app that puts every publisher's world into your pocket.",
      cta1: "Download the Demo App",
      cta2: "Explore Magazines",
      ticker: ["Built on Flutter", "PDF → Interactive", "Publisher Ready"],
      quote: "\u201CEvery page a portal. Every issue a universe.\u201D",
      quoteWho: "Editorial Team",
    },
    marquee: { title: "Trusted by world-class brands" },
    features: {
      kicker: "Capabilities",
      sub: "Six pillars power the Paigez experience — engineered for publishers, polished for readers, and unmistakably native.",
      cards: [
        { title: "PDF → Interactive", body: "Every third-party PDF magazine is digitised into rich, tappable, animated pages — no more static layouts." },
        { title: "Native Super App", body: "Built end-to-end on Google's Flutter framework for buttery performance on iOS and Android." },
        { title: "Fully Immersive", body: "Scroll-triggered animations, audio moments, embedded video, and page-turn physics." },
        { title: "Multi-title Library", body: "One app, every title. Manage subscriptions and download issues offline in a single vault." },
        { title: "Lightning Reader", body: "Cached rendering keeps everything smooth even on flaky connections." },
      ],
      aiBadge: "Publisher-Grade · AI-Powered · Flutter Native",
      aiSub: "Our Flutter framework ships with a full suite of AI capabilities that turn every digitised issue into a smarter, more accessible, more global product — out of the box.",
      aiCards: [
        { title: "Multi-language Translation", body: "AI-powered, near-instant translation into 40+ languages — expand a single issue to a global readership without re-typesetting." },
        { title: "Text-to-Voice Narration", body: "Studio-grade AI voices read every article aloud with natural cadence, letting readers 'listen to the magazine' on the go." },
        { title: "AI Article Summaries", body: "Automatic executive summaries and pull-quotes surface the essence of long-form editorial in seconds." },
        { title: "Semantic Search", body: "Ask questions in natural language across every issue in your library — AI finds the exact page, spread, or quote." },
        { title: "Adaptive Accessibility", body: "Dynamic font scaling, contrast modes, alt-text generation, and dyslexia-friendly rendering baked into every title." },
        { title: "Publisher Analytics", body: "Real-time engagement heat-maps, dwell time, and monetisation insights — plus white-label and DRM-friendly delivery." },
      ],
      aiFooter: "White-label ready · DRM-friendly delivery · Real-time engagement analytics",
    },
    how: {
      kicker: "The Process",
      sub: "A four-step pipeline that lets any legacy publication become a native, immersive magazine.",
      steps: [
        { title: "Ingest the PDF", body: "Publishers hand us the original PDF magazine. We extract structure, imagery, typography, and page hierarchy." },
        { title: "Reimagine Every Page", body: "Our editors and AI-assisted tools rebuild each spread into interactive Flutter components — animations, hotspots, embedded media." },
        { title: "Compile Into the Super App", body: "The issue is packaged inside the Paigez native super app alongside every other title from your library." },
        { title: "Ship to Readers", body: "Readers download once, keep every issue, and enjoy silky offline reading with page-turn physics that feel real." },
      ],
    },
    showcase: {
      kicker: "Selected Work",
      sub: "A snapshot of iconic titles Paigez has already reimagined as fully immersive, native digital editions — from world sport to premium luxury.",
      moreHighlights: "& more highlights",
      issues: [
        { title: "Formula 1 Race Programme Official Magazine", meta: "Sport · Race Programme" },
        { title: "FIFA World Cup Qatar 2022 — Official Magazine", meta: "Sport · Tournament" },
        { title: "Red Bulletin Monthly Magazine", meta: "Culture · Monthly" },
        { title: "Simply Abu Dhabi Magazine", meta: "Travel & Luxury · Monthly" },
      ],
      featuredKicker: "Featured Case Study",
      featuredSub: "The Final Magazine",
      featuredMeta: "Sport · Tournament",
      featuredBody: "A native, immersive digital edition produced for the final of the world's biggest sporting event — every page interactive, every spread built to be lived rather than read.",
      bottomNote: "A selection of previously produced immersive digital editions",
    },
    testimonials: {
      kicker: "Voices",
      quotes: [
        {
          paragraphs: [
            "Personalisation is becoming more important than ever in the airline industry and offering the right products to the right person at the right time makes the difference between a good on-board experience and a great one.",
            "Through our partnership with Paigez.ai, we hope to further digitise and break new ground in inflight retail.",
            "By combining Paigez.ai's high-end digital magazine publication platform with our retail capabilities and end-to-end technology platform, we are able to upgrade the passenger experience and provide them with a more flexible and custom-built retail offer.",
          ],
          who: "Stefan Paterman",
          role: "CEO, Retail inMotion",
        },
        {
          paragraphs: [
            "The new F1 fully interactive digital race programme offers the fan, whether at track or at home, a unique experience.",
            "Everything from team and driver profiles, up-to-date editorial features, and highly interactive partner ads has taken the race programme to the next level. Paigez.ai's beautifully curated digital content is sure to be a popular addition to the fan experience across the season.",
            "A true magazine experience now fully enhanced and available to every fan around the world for each race.",
          ],
          who: "Joan Carrera Lopez",
          role: "Senior Manager, Retail & CPG Licensing at Formula 1®",
        },
      ],
    },
    download: {
      kicker: "The Super App",
      line1: "Every magazine.",
      line2: "One immersive home.",
      sub: "Paigez.ai is launching soon on iOS and Android. Be first to turn a new leaf.",
      comingTo: "Coming to",
      soon: "Soon",
      foot: "Built with Google Flutter · Native on iOS & Android",
    },
    contact: {
      kicker: "Get in touch",
      sub: "Whether you're a publisher looking to digitise your catalogue, a reader with feedback, or press — we'd love to hear from you.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      phName: "Your name",
      phEmail: "you@company.com",
      phSubject: "Partnership, press, feedback...",
      phMessage: "Tell us a little about your project...",
      send: "Send Message",
      sending: "Sending",
      toastFill: "Please fill in every field.",
      toastSent: "Message sent",
      toastSentDesc: "We'll reply within one business day.",
      toastReceived: "Message received",
      toastReceivedDesc: "We've saved your note. Live email delivery goes on soon.",
      toastSavedFail: "Saved, but delivery failed",
      toastSavedFailDesc: "We stored your message and will reach out manually.",
      toastError: "Something went wrong",
      toastErrorDesc: "Please try again in a moment.",
    },
    footer: {
      tagline: "Turn a new leaf.",
      about: "Paigez.ai is a fully immersive digital magazine super app, built on Google Flutter, digitising the world's PDF publications into native interactive experiences.",
      explore: "Explore",
      contact: "Contact",
      enquiries: "Publisher enquiries welcome",
      rights: "All rights reserved.",
      crafted: "Crafted with Flutter · Immersive by design.",
    },
  },

  ar: {
    nav: {
      links: [
        { href: "#features", label: "المزايا" },
        { href: "#how-it-works", label: "كيف يعمل" },
        { href: "#showcase", label: "أعمالنا" },
        { href: "#testimonials", label: "آراء" },
        { href: "#contact", label: "تواصل معنا" },
      ],
      cta: "حمّل التطبيق التجريبي",
    },
    hero: {
      badge: "مبني على فلاتر · غامر · أصلي",
      sub: "تحوّل Paigez.ai مجلات PDF الثابتة إلى تجارب تفاعلية غامرة بالكامل — تطبيق خارق أصلي يضع عالم كل ناشر في جيبك.",
      cta1: "حمّل التطبيق التجريبي",
      cta2: "استكشف المجلات",
      ticker: ["مبني على فلاتر", "من PDF إلى تفاعلي", "جاهز للناشرين"],
      quote: "\u201Cكل صفحة بوابة. كل عدد عالمٌ بأكمله.\u201D",
      quoteWho: "فريق التحرير",
    },
    marquee: { title: "موثوق من علامات تجارية عالمية" },
    features: {
      kicker: "القدرات",
      sub: "ستة ركائز تشغّل تجربة Paigez — مصمّمة للناشرين، مصقولة للقرّاء، وأصلية بلا منازع.",
      cards: [
        { title: "من PDF إلى تفاعلي", body: "تُحوَّل كل مجلة PDF إلى صفحات غنية متحركة قابلة للمس — وداعاً للتصاميم الثابتة." },
        { title: "تطبيق خارق أصلي", body: "مبني بالكامل على إطار عمل فلاتر من Google لأداء فائق السلاسة على iOS وأندرويد." },
        { title: "غامر بالكامل", body: "رسوم متحركة تتفاعل مع التمرير، لحظات صوتية، فيديو مدمج، وفيزياء واقعية لتقليب الصفحات." },
        { title: "مكتبة متعددة العناوين", body: "تطبيق واحد لكل العناوين. أدر الاشتراكات وحمّل الأعداد للقراءة دون اتصال في مكان واحد." },
        { title: "قارئ فائق السرعة", body: "العرض المخزّن مؤقتاً يُبقي كل شيء سلساً حتى مع الاتصالات الضعيفة." },
      ],
      aiBadge: "بمستوى الناشرين · مدعوم بالذكاء الاصطناعي · فلاتر أصلي",
      aiSub: "يأتي إطار فلاتر لدينا مع مجموعة كاملة من قدرات الذكاء الاصطناعي التي تحوّل كل عدد رقمي إلى منتج أذكى وأكثر شمولاً وعالمية — جاهزة فور التشغيل.",
      aiCards: [
        { title: "ترجمة متعددة اللغات", body: "ترجمة شبه فورية مدعومة بالذكاء الاصطناعي إلى أكثر من 40 لغة — وسّع انتشار عددٍ واحد إلى قرّاء العالم دون إعادة تنسيق." },
        { title: "سرد صوتي للنصوص", body: "أصوات ذكاء اصطناعي باحترافية الاستوديو تقرأ كل مقال بإيقاع طبيعي، ليستمع القرّاء إلى المجلة أثناء التنقل." },
        { title: "ملخصات مقالات ذكية", body: "ملخصات تنفيذية واقتباسات بارزة تلقائية تستخرج جوهر المقالات الطويلة في ثوانٍ." },
        { title: "بحث دلالي", body: "اطرح أسئلة بلغة طبيعية عبر كل الأعداد في مكتبتك — يجد الذكاء الاصطناعي الصفحة أو الاقتباس بدقة." },
        { title: "إتاحة تكيفية", body: "تحجيم ديناميكي للخط، أوضاع تباين، توليد نصوص بديلة، وعرض ملائم لعسر القراءة في كل عنوان." },
        { title: "تحليلات الناشرين", body: "خرائط تفاعل حرارية فورية، ومدة القراءة، ورؤى تحقيق الدخل — مع تسليم يدعم العلامة البيضاء وحماية DRM." },
      ],
      aiFooter: "جاهز للعلامة البيضاء · تسليم متوافق مع DRM · تحليلات تفاعل لحظية",
    },
    how: {
      kicker: "آلية العمل",
      sub: "مسار من أربع خطوات يحوّل أي إصدار تقليدي إلى مجلة أصلية غامرة.",
      steps: [
        { title: "استلام ملف PDF", body: "يسلّمنا الناشرون مجلة PDF الأصلية، فنستخرج البنية والصور والخطوط وتسلسل الصفحات." },
        { title: "إعادة تصوّر كل صفحة", body: "يعيد محررونا وأدواتنا المدعومة بالذكاء الاصطناعي بناء كل صفحة إلى مكوّنات فلاتر تفاعلية — رسوم متحركة ونقاط تفاعل ووسائط مدمجة." },
        { title: "التجميع داخل التطبيق الخارق", body: "يُضمَّن العدد داخل تطبيق Paigez الأصلي إلى جانب كل عنوان آخر في مكتبتك." },
        { title: "الوصول إلى القرّاء", body: "يحمّل القرّاء التطبيق مرة واحدة، ويحتفظون بكل عدد، ويستمتعون بقراءة سلسة دون اتصال مع فيزياء واقعية لتقليب الصفحات." },
      ],
    },
    showcase: {
      kicker: "أعمال مختارة",
      sub: "لمحة عن عناوين أيقونية أعادت Paigez تصورها بالفعل كإصدارات رقمية أصلية غامرة بالكامل — من الرياضة العالمية إلى الفخامة الراقية.",
      moreHighlights: "والمزيد من الأعمال",
      issues: [
        { title: "المجلة الرسمية لبرنامج سباقات الفورمولا 1", meta: "رياضة · برنامج سباق" },
        { title: "المجلة الرسمية لكأس العالم FIFA قطر 2022", meta: "رياضة · بطولة" },
        { title: "مجلة Red Bulletin الشهرية", meta: "ثقافة · شهرية" },
        { title: "مجلة Simply Abu Dhabi", meta: "سفر وفخامة · شهرية" },
      ],
      featuredKicker: "دراسة حالة مميزة",
      featuredSub: "مجلة المباراة النهائية",
      featuredMeta: "رياضة · بطولة",
      featuredBody: "إصدار رقمي أصلي غامر أُنتج لنهائي أكبر حدث رياضي في العالم — كل صفحة تفاعلية، وكل مساحة صُممت لتُعاش لا لتُقرأ فحسب.",
      bottomNote: "مختارات من الإصدارات الرقمية الغامرة المنتجة سابقاً",
    },
    testimonials: {
      kicker: "آراء",
      quotes: [
        {
          paragraphs: [
            "أصبح التخصيص أكثر أهمية من أي وقت مضى في قطاع الطيران، وتقديم المنتجات المناسبة للشخص المناسب في الوقت المناسب هو ما يصنع الفرق بين تجربة جيدة على متن الطائرة وتجربة استثنائية.",
            "من خلال شراكتنا مع Paigez.ai، نأمل في مواصلة الرقمنة وفتح آفاق جديدة في تجارة التجزئة على متن الطائرات.",
            "بدمج منصة Paigez.ai الراقية للمجلات الرقمية مع قدراتنا في التجزئة ومنصتنا التقنية المتكاملة، يمكننا الارتقاء بتجربة المسافر وتقديم عرض تجزئة أكثر مرونة وتخصيصاً.",
          ],
          who: "Stefan Paterman",
          role: "الرئيس التنفيذي، Retail inMotion",
        },
        {
          paragraphs: [
            "يقدّم برنامج سباق الفورمولا 1 الرقمي التفاعلي الجديد تجربة فريدة للمشجع، سواء في الحلبة أو في المنزل.",
            "كل شيء من ملفات الفرق والسائقين، والمقالات التحريرية المحدّثة، وإعلانات الشركاء التفاعلية، ارتقى ببرنامج السباق إلى مستوى جديد. المحتوى الرقمي المنسق بإتقان من Paigez.ai سيكون بلا شك إضافة محبوبة لتجربة المشجعين على مدار الموسم.",
            "تجربة مجلة حقيقية، معزَّزة بالكامل ومتاحة الآن لكل مشجع حول العالم في كل سباق.",
          ],
          who: "Joan Carrera Lopez",
          role: "مدير أول، التجزئة وترخيص السلع الاستهلاكية في Formula 1®",
        },
      ],
    },
    download: {
      kicker: "التطبيق الخارق",
      line1: "كل المجلات.",
      line2: "موطن واحد غامر.",
      sub: "ينطلق Paigez.ai قريباً على iOS وأندرويد. كن أول من يقلب صفحة جديدة.",
      comingTo: "قريباً على",
      soon: "قريباً",
      foot: "مبني بواسطة Google Flutter · أصلي على iOS وأندرويد",
    },
    contact: {
      kicker: "تواصل معنا",
      sub: "سواء كنت ناشراً يسعى لرقمنة إصداراته، أو قارئاً لديه ملاحظات، أو صحفياً — يسعدنا أن نسمع منك.",
      name: "الاسم",
      email: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "الرسالة",
      phName: "اسمك",
      phEmail: "you@company.com",
      phSubject: "شراكة، صحافة، ملاحظات...",
      phMessage: "أخبرنا قليلاً عن مشروعك...",
      send: "أرسل الرسالة",
      sending: "جارٍ الإرسال",
      toastFill: "يرجى تعبئة جميع الحقول.",
      toastSent: "تم إرسال الرسالة",
      toastSentDesc: "سنرد عليك خلال يوم عمل واحد.",
      toastReceived: "تم استلام الرسالة",
      toastReceivedDesc: "حفظنا رسالتك، وسيتم تفعيل البريد المباشر قريباً.",
      toastSavedFail: "حُفظت الرسالة لكن تعذّر الإرسال",
      toastSavedFailDesc: "خزّنّا رسالتك وسنتواصل معك يدوياً.",
      toastError: "حدث خطأ ما",
      toastErrorDesc: "يرجى المحاولة مرة أخرى بعد قليل.",
    },
    footer: {
      tagline: "اقلب صفحة جديدة.",
      about: "Paigez.ai هو تطبيق خارق للمجلات الرقمية الغامرة بالكامل، مبني على Google Flutter، يحوّل منشورات PDF حول العالم إلى تجارب تفاعلية أصلية.",
      explore: "استكشف",
      contact: "تواصل",
      enquiries: "نرحّب باستفسارات الناشرين",
      rights: "جميع الحقوق محفوظة.",
      crafted: "صُنع بواسطة فلاتر · غامر بتصميمه.",
    },
  },
};
